(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myshie-video-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('myshie-video-carousel')) {
  customElements.define('myshie-video-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.myshie-videos__track');
      this.nav = this.querySelector('.myshie-videos__nav');
      this.update = () => {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.nav.hidden = maximum < 2;
        const position = Math.abs(this.track.scrollLeft);
        this.nav.querySelector('[data-direction="-1"]').disabled = position < 2;
        this.nav.querySelector('[data-direction="1"]').disabled = position >= maximum - 2;
      };
      this.nav.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
        const card = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({left:(card.getBoundingClientRect().width + gap) * Number(button.dataset.direction) * rtl, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal}));
      this.track.addEventListener('scroll', this.update, {passive:true,signal});
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.videos = [...this.querySelectorAll('video')];
      this.visibleVideos = new Set();
      this.pausedByUser = new Set();
      this.autoplayEnabled = () => this.dataset.autoplay === 'true' && !this.motion.matches;
      this.syncPlayback = () => {
        this.videos.forEach(video => {
          if (document.hidden || !this.visibleVideos.has(video)) {
            video.pause();
          } else if (this.autoplayEnabled() && !this.pausedByUser.has(video)) {
            video.play().catch(() => {});
          }
        });
      };
      this.videos.forEach(video => {
        const controls = video.parentElement.querySelector('.myshie-videos__playback');
        const play = controls.querySelector('[data-play]');
        const mute = controls.querySelector('[data-mute]');
        video.playsInline = true;
        if (this.autoplayEnabled()) video.muted = true;
        controls.hidden = false;
        const updateControls = () => {
          const playLabel = video.paused ? play.dataset.playLabel : play.dataset.pauseLabel;
          const muteLabel = video.muted ? mute.dataset.unmuteLabel : mute.dataset.muteLabel;
          play.textContent = playLabel;
          play.setAttribute('aria-label', playLabel);
          mute.textContent = muteLabel;
          mute.setAttribute('aria-label', muteLabel);
        };
        play.addEventListener('click', () => {
          if (video.paused) { this.pausedByUser.delete(video); video.play().catch(() => {}); }
          else { this.pausedByUser.add(video); video.pause(); }
        }, {signal});
        mute.addEventListener('click', () => { video.muted = !video.muted; }, {signal});
        video.addEventListener('play', () => {
          if (!video.muted) document.querySelectorAll('myshie-video-carousel video').forEach(other => { if (other !== video) other.muted = true; });
          updateControls();
        }, {signal});
        video.addEventListener('pause', () => {
          if (this.visibleVideos.has(video) && !document.hidden && !this.motion.matches) this.pausedByUser.add(video);
          updateControls();
        }, {signal});
        video.addEventListener('volumechange', () => {
          if (!video.muted) document.querySelectorAll('myshie-video-carousel video').forEach(other => { if (other !== video) other.muted = true; });
          updateControls();
        }, {signal});
        updateControls();
      });
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if(entry.isIntersecting && entry.intersectionRatio >= .55) this.visibleVideos.add(entry.target); else this.visibleVideos.delete(entry.target); });
        this.syncPlayback();
      }, {threshold:[0,.55]});
      this.videos.forEach(video => this.observer.observe(video));
      document.addEventListener('visibilitychange', this.syncPlayback, {signal});
      this.motion.addEventListener('change', () => { if(this.motion.matches) this.videos.forEach(video => video.pause()); else this.syncPlayback(); }, {signal});
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); this.resize?.disconnect(); this.observer?.disconnect(); this.querySelectorAll('video').forEach(video => video.pause()); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
